import {
  DashboardOutlined,
  TeamOutlined,
  SafetyOutlined,
  SettingOutlined,
  ShoppingOutlined,
  UserOutlined,
  FileTextOutlined,
  WalletOutlined,
  BarChartOutlined,
  CarOutlined,
  FundOutlined,
  InboxOutlined,
  BellOutlined,
  ShopOutlined,
  AccountBookOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';

const appendGroup = (items, key, icon, label, children) => {
  if (children.length) {
    items.push({ key, icon, label, children });
  }
};

export const getMenuItems = (hasPermission, user) => {
  const items = [];
  const isPlatform = user && user.is_super === 1 && user.adminShopId === 1 && user.shopId === 1;
  const workbench = [];
  const fulfillment = [];
  const customerAssets = [];
  const operations = [];
  const riskControl = [];
  const platform = [];

  if (hasPermission('dashboard:view')) {
    workbench.push({
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    });
  }

  // 商户管理 / 分账管理 / 分账接收方仅平台管理员可见，不参与权限分配
  if (isPlatform) {
    operations.push({
      key: '/shops',
      icon: <ShopOutlined />,
      label: '商户管理',
    });
  }
  if (isPlatform) {
    riskControl.push({
      key: '/profit-sharing',
      icon: <AccountBookOutlined />,
      label: '分账管理',
    });
  }
  if (isPlatform) {
    riskControl.push({
      key: '/profit-sharing-receivers',
      icon: <UsergroupAddOutlined />,
      label: '分账接收方',
    });
  }
  if (hasPermission('admin:view')) {
    platform.push({
      key: '/admins',
      icon: <TeamOutlined />,
      label: '管理员管理',
    });
  }
  if (hasPermission('permission:view')) {
    platform.push({
      key: '/permissions',
      icon: <SafetyOutlined />,
      label: '权限管理',
    });
  }
  if (hasPermission('config:view')) {
    platform.push({
      key: '/system-config',
      icon: <SettingOutlined />,
      label: '系统配置',
    });
  }
  // 充值订单
  if (hasPermission('recharge_order:view')) {
    fulfillment.push({
      key: '/recharge-orders',
      icon: <WalletOutlined />,
      label: '充值订单',
    });
  }
  // 配送订单
  if (hasPermission('delivery_order:view')) {
    fulfillment.push({
      key: '/delivery-orders',
      icon: <ShoppingOutlined />,
      label: '配送订单',
    });
  }
  // 订单统计（使用原权限 order-stats:view）
  if (hasPermission('order-stats:view')) {
    operations.push({
      key: '/order-stats',
      icon: <BarChartOutlined />,
      label: '订单统计',
    });
  }
  if (hasPermission('user:view')) {
    customerAssets.push({
      key: '/users',
      icon: <UserOutlined />,
      label: '用户管理',
    });
  }
  if (hasPermission('refund:view')) {
    fulfillment.push({
      key: '/refunds',
      icon: <FileTextOutlined />,
      label: '退桶申请',
    });
  }
  // 派单工作台
  if (hasPermission('dispatch:view')) {
    fulfillment.push({
      key: '/delivery-manage',
      icon: <CarOutlined />,
      label: '派单管理',
    });
  }
  // 送水员绩效
  if (hasPermission('delivery_stats:view')) {
    operations.push({
      key: '/delivery-stats',
      icon: <FundOutlined />,
      label: '绩效统计',
    });
  }
  // 桶量核对
  if (hasPermission('bucket_reconcile:view')) {
    customerAssets.push({
      key: '/bucket-reconcile',
      icon: <InboxOutlined />,
      label: '桶量核对',
    });
  }
  if (hasPermission('log:view')) {
    platform.push({
      key: '/operation-logs',
      icon: <FileTextOutlined />,
      label: '操作日志',
    });
  }
  if (hasPermission('notification_log:view')) {
    platform.push({
      key: '/notification-logs',
      icon: <BellOutlined />,
      label: '通知日志',
    });
  }
  if (isPlatform) {
    riskControl.push({
      key: '/oa-risk',
      icon: <SafetyOutlined />,
      label: 'OA风控',
    });
  }

  appendGroup(items, 'group-workbench', <DashboardOutlined />, '工作台', workbench);
  appendGroup(items, 'group-fulfillment', <ShoppingOutlined />, '订单履约', fulfillment);
  appendGroup(items, 'group-assets', <WalletOutlined />, '用户资金', customerAssets);
  appendGroup(items, 'group-operations', <ShopOutlined />, '商家经营', operations);
  appendGroup(items, 'group-risk', <SafetyOutlined />, '风控对账', riskControl);
  appendGroup(items, 'group-platform', <SettingOutlined />, '平台中心', platform);

  return items;
};

const findLeafContext = (items, pathname, parentKeys = []) => {
  for (const item of items) {
    if (item.children?.length) {
      const matched = findLeafContext(item.children, pathname, [...parentKeys, item.key]);
      if (matched) return matched;
      continue;
    }

    if (pathname === item.key || pathname.startsWith(`${item.key}/`)) {
      return { selectedKey: item.key, openKeys: parentKeys };
    }
  }

  return null;
};

export const findMenuState = (items, pathname) => {
  const matched = findLeafContext(items, pathname);
  if (matched) return matched;

  const firstGroup = items.find((item) => item.children?.length);
  const firstLeaf = firstGroup?.children?.[0];
  return {
    selectedKey: firstLeaf?.key,
    openKeys: firstGroup ? [firstGroup.key] : [],
  };
};